import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fmtDate } from "../lib/api";
import { BadgeCheck, ShieldX, Loader2, Award } from "lucide-react";

export default function VerifyArticle() {
  const { code } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/recherche/validation-verify/${code}`).then(({ data }) => setData(data)).catch(() => setData({ valid: false }));
  }, [code]);

  if (!data) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="animate-spin text-[#0E7C7B]" size={28} /></div>;

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-xl items-center px-4 py-16" data-testid="verify-article-page">
      <div className="w-full rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <p className="flex items-center justify-center gap-2 text-center font-mono text-xs uppercase tracking-widest text-[#0E7C7B]">
          <Award size={15} /> Cabinet CARIS Santé — Validation scientifique
        </p>
        {data.valid ? (
          <div className="mt-6 text-center" data-testid="verify-article-valid">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100">
              <BadgeCheck size={34} className="text-emerald-600" />
            </div>
            <h1 className="mt-4 font-display text-2xl font-bold text-navy">Publication validée</h1>
            <p className="mt-1 text-sm text-slate-500">Ce certificat de validation scientifique est authentique.</p>
            <div className="mt-6 space-y-3 rounded-2xl bg-slate-50 p-5 text-left text-sm">
              <div className="flex justify-between gap-4"><span className="text-slate-400">Titre</span><span className="text-right font-semibold text-navy" data-testid="verify-article-title">{data.title}</span></div>
              <div className="flex justify-between gap-4"><span className="text-slate-400">Auteur(s)</span><span className="text-right font-semibold text-navy">{data.authors || "—"}</span></div>
              <div className="flex justify-between gap-4"><span className="text-slate-400">Thème</span><span className="font-semibold text-navy">{data.theme || "—"}{data.year ? ` · ${data.year}` : ""}</span></div>
              <div className="flex justify-between gap-4"><span className="text-slate-400">Validé par</span><span className="font-semibold text-navy">{data.validated_by || "Comité scientifique"}</span></div>
              {data.validated_at && <div className="flex justify-between gap-4"><span className="text-slate-400">Validé le</span><span className="font-semibold text-navy" data-testid="verify-article-date">{fmtDate(data.validated_at)}</span></div>}
              {data.plagiat_verdict && <div className="flex justify-between gap-4"><span className="text-slate-400">Intégrité</span>
                <span className={`font-semibold ${data.plagiat_verdict === "conforme" ? "text-emerald-600" : "text-amber-600"}`}>
                  {data.plagiat_score != null ? `${data.plagiat_score}% · ` : ""}{data.plagiat_verdict === "conforme" ? "Conforme" : "À revoir"}
                </span></div>}
            </div>
          </div>
        ) : (
          <div className="mt-6 text-center" data-testid="verify-article-invalid">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100"><ShieldX size={34} className="text-red-600" /></div>
            <h1 className="mt-4 font-display text-2xl font-bold text-navy">Certificat introuvable</h1>
            <p className="mt-1 text-sm text-slate-500">Aucune publication validée ne correspond au code « {code} ».</p>
          </div>
        )}
      </div>
    </div>
  );
}
